export interface PasswordValidation {
  isValid: boolean;
  errors: string[];
}

export function validatePassword(password: string): PasswordValidation {
  const errors: string[] = [];

  if (password.length < 12) {
    errors.push('At least 12 characters');
  }

  if (!/[A-Z]/.test(password)) {
    errors.push('At least one uppercase letter');
  }

  if (!/[a-z]/.test(password)) {
    errors.push('At least one lowercase letter');
  }

  if (!/[0-9]/.test(password)) {
    errors.push('At least one number');
  }

  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('At least one special character (!@#$%^&*...)');
  }

  const commonPasswords = [
    'password123', '123456789', 'qwerty123', 'admin123',
    'welcome123', 'letmein123', 'password1234', '12345678901',
    'password1234567'
  ];
  
  if (commonPasswords.includes(password.toLowerCase())) {
    errors.push('Not a common password');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

export function getPasswordStrength(password: string): {
  strength: 'weak' | 'fair' | 'good' | 'strong';
  score: number;
  color: string;
} {
  let score = 0;

  if (password.length >= 12) score += 20;
  if (password.length >= 16) score += 10;
  if (password.length >= 20) score += 10;
  
  if (/[a-z]/.test(password)) score += 15;
  if (/[A-Z]/.test(password)) score += 15;
  if (/[0-9]/.test(password)) score += 15;
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score += 15;

  const uniqueChars = new Set(password).size;
  if (uniqueChars > 10) score += 10;

  // The awards above total 110. Callers render this straight into a
  // LinearProgress, which expects 0-100, so cap it here rather than making
  // every call site remember to clamp.
  score = Math.min(100, score);

  if (score < 40) return { strength: 'weak', score, color: '#f44336' };
  if (score < 60) return { strength: 'fair', score, color: '#ff9800' };
  if (score < 80) return { strength: 'good', score, color: '#ffc107' };
  return { strength: 'strong', score, color: '#4caf50' };
}
